import { alpha, Chip } from "@mui/material";
import { blue, orange } from "@mui/material/colors";
import { RecordCircle } from "iconsax-react";

function StatusIcon({ status }) {

  if (status === "Activo") {
    return <Chip
      sx={{
        color: '#53CA98',
        backgroundColor: alpha(
          '#53CA98',
          0.1
        ),
      }}
      icon={
        <RecordCircle size="12" variant="Bold" />
      }
      label="Activo"
      size="small"
    />
  } else if (status === "Inactivo") {
    return <Chip
      sx={{
        color: '#DB463C',
        backgroundColor: alpha(
          '#DB463C',
          0.1
        ),
      }}
      icon={
        <RecordCircle size="12" variant="Bold" />
      }
      label="Inactivo"
      size="small"
    />
  } else if (status === "Confianza") {
    return <Chip
      sx={{
        color: blue[400],
        backgroundColor: alpha(
          blue[500],
          0.1
        ),
      }}
      icon={
        <RecordCircle size="12" variant="Bold" />
      }
      label="Confianza"
      size="small"
    />
  } else if (status === "No confianza") {
    return <Chip
      sx={{
        color: orange[500],
        backgroundColor: alpha(
          orange[500],
          0.1
        ),
      }}
      icon={
        <RecordCircle size="12" variant="Bold" />
      }
      label="No confianza"
      size="small"
    />
  }
}

export const columns = [
  {
    field: "id",
    headerName: "ID",
    width: 40,
    resizable: false,
    sortable: false,
    renderHeader: (params) => <strong>ID</strong>,
  },
  {
    field: "user_name",
    headerName: "NOMBRE",
    minWidth: 240,
    flex: 1,
    resizable: false,
    sortable: false,
    renderHeader: (params) => <strong>NOMBRE</strong>,
  },
  {
    field: "status",
    headerName: "TIPO",
    minWidth: 160,
    resizable: false,
    sortable: false,
    renderHeader: (params) => <strong>TIPO</strong>,
    renderCell: (params) => <StatusIcon status={params.value} />,
  },
  {
    field: "type",
    headerName: "ESTADO",
    minWidth: 100,
    resizable: false,
    sortable: false,
    headerAlign: "left",
    align: "left",
    renderHeader: (params) => <strong>ESTADO</strong>,
    renderCell: (params) => <StatusIcon status={params.value} />,
  },
  {
    field: "statusAccount",
    headerName: "ESTADO CUENTA",
    minWidth: 160,
    resizable: false,
    sortable: false,
    renderHeader: (params) => <strong>ESTADO CUENTA</strong>,
  },
  {
    field: "business_name",
    headerName: "NEGOCIO",
    type: "string",
    minWidth: 160,
    resizable: false,
    sortable: false,
    headerAlign: "left",
    renderHeader: (params) => <strong>NEGOCIO</strong>,
  },
  {
    field: "membership",
    headerName: "CATEGORÍA",
    type: "string",
    minWidth: 160,
    resizable: false,
    sortable: false,
    headerAlign: "left",
    renderHeader: (params) => <strong>CATEGORÍA</strong>,
  },
  {
    field: "credits",
    headerName: "CREDITOS",
    type: "string",
    width: 120,
    resizable: false,
    sortable: false,
    headerAlign: "left",
    align: "left",
    renderHeader: (params) => <strong>CREDITOS</strong>,
  },
  {
    field: "balance",
    headerName: "SALDO",
    type: "string",
    width: 120,
    resizable: false,
    sortable: false,
    headerAlign: "left",
    align: "left",
    renderHeader: (params) => <strong>SALDO</strong>,
  },
];
